<template>
  <youtube
    class="text-center"
    :video-id="videoId"
    :player-vars="{ autoplay: 1, rel: 0 }"
    @ready="ready"
  />
</template>

<script>
  export default {
    name: 'HelpVideoComponent',
    data() {
      return {
        videoId: 'sM5peV4yUAc',
        player: null,
      };
    },
    mounted() {
      this.$bus.$on('modal-video-help-open', this.resetVideo);
    },
    destroyed() {
      this.$bus.$off('modal-video-help-open');
    },
    methods: {
      ready(event) {
        this.player = event.target;
      },
      resetVideo() {
        if (this.player) {
          this.player.seekTo(0);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  /deep/.embed-responsive {
    width: 80%;
    margin: auto;
  }
</style>
